export default __webpack_public_path__ + "static/media/iediong.faf67146.jpg";